import { csx, Flex, MenuButton, MenuButtonProps } from '@vtex/admin-ui'

type MenuButtonWithIconProps = MenuButtonProps & {
  icon: React.ReactNode
}

const buttonStyle = csx({
  button: {
    // Hides default arrow icon
    '> div > svg': {
      display: 'none',
    },
    // Styles label to comply with menu button variant
    '.label': {
      columnGap: '$space-1',
      color: '$action.main.secondary',
      fontVariationSettings:
        'var(--admin-ui-text-action1-fontVariationSettings)',
    },
  },
})

export function MenuButtonWithIcon(props: MenuButtonWithIconProps) {
  return (
    <span className={buttonStyle}>
      <MenuButton
        {...props}
        aria-label={props.label?.toString()}
        label={
          <Flex direction="row" className="label">
            {props.icon}
            {props.label}
          </Flex>
        }
      />
    </span>
  )
}
